<div
  class="notifications-container"
  *ngIf="notification._state | async as n"
  [ngClass]="{ show: n?.state, hide: !n?.state }"
>
  <button (click)="notification.hideNotification()">
    <i data-feather="x"></i>
  </button>
  <div [ngClass]="n?.severity" class="wrapper flex items-start gap-4">
    <div class="icon-container">
      <i *ngIf="n?.severity === 'info'" data-feather="info"></i>
      <i *ngIf="n?.severity === 'neutral'" data-feather="info"></i>
      <i *ngIf="n?.severity === 'success'" data-feather="check-circle"></i>
      <i *ngIf="n?.severity === 'warning'" data-feather="alert-triangle"></i>
      <i *ngIf="n?.severity === 'error'" data-feather="alert-circle"></i>
    </div>

    <div class="message">
      <p>{{ n?.severity | titlecase }}</p>
      <p>{{ n?.message }}</p>
    </div>
  </div>
</div>
